import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { seguridadDAModulo } from 'src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule';
import { AplicacionFrontModel } from '../model/aplicacionFrontModel';
import { AplicacionModel } from '../model/aplicacionModel';

@Injectable({
  providedIn: 'root'
})
export class AplicacionService {

  diccionarioUrl: any;
  urlUniforme: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = seguridadDAModulo.url.seguridad;
  }

  getAllAplicacion() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.aplicacion);
  } 

  createAplicacion(item: AplicacionFrontModel){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.aplicacion, item);
  }

  updateAplicacion(item: AplicacionFrontModel){
    return this.commom.peticionPutConHeader(this.urlUniforme + this.diccionarioUrl.aplicacion, item);
  }

  deleteAplicacion(identifier: number){
    return this.commom.peticionDeleteConHeader(this.urlUniforme + this.diccionarioUrl.aplicacion + '/' + identifier);
  }

}
